// import { convertLatexToAsciiMath } from "mathlive";

import { MathfieldElement } from "mathlive";

import logError from "seneca-common/utils/sentry/logError";

import { sanitiseAsciiMath, sanitiseLatexString } from "../sanitisations";

export function getAsciiFromLatex(latex: string) {
  try {
    const mf = document.getElementById("hidden-mfe") as MathfieldElement;
    const sanitisedLatex = sanitiseLatexString(latex);
    mf.setValue("", { format: "latex" });
    mf.setValue(sanitisedLatex, { format: "latex" });
    const asciiMath = mf.getValue("ascii-math");
    return sanitiseAsciiMath(asciiMath);
  } catch (err) {
    logError(err, {
      message: "getAsciiFromLatex error"
    });
    return "";
  }
}
